import type { IcsWorkerRequest, IcsWorkerResponse } from "@/workers/icsParser.worker";

let worker: Worker | null = null;

function getWorker(): Worker {
  if (!worker) {
    worker = new Worker(
      new URL("../workers/icsParser.worker.ts", import.meta.url),
      { type: "module" },
    );
  }
  return worker;
}

/** Parse ICS off the main thread for large holiday feeds. */
export function parseIcsDatesInWorker(icsText: string): Promise<Record<string, string>> {
  return new Promise((resolve, reject) => {
    const w = getWorker();
    const onMessage = (event: MessageEvent<IcsWorkerResponse>) => {
      w.removeEventListener("message", onMessage);
      w.removeEventListener("error", onError);
      if (event.data.type === "result") resolve(event.data.holidays);
      else reject(new Error(event.data.message));
    };
    const onError = () => {
      w.removeEventListener("message", onMessage);
      w.removeEventListener("error", onError);
      reject(new Error("ICS worker failed"));
    };
    w.addEventListener("message", onMessage);
    w.addEventListener("error", onError);
    w.postMessage({ type: "parse", icsText } satisfies IcsWorkerRequest);
  });
}
